import { render, staticRenderFns } from "./TransitSelectedPlanet.vue?vue&type=template&id=2225af36&"
import script from "./TransitSelectedPlanet.vue?vue&type=script&lang=js&"
export * from "./TransitSelectedPlanet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports